<template>
    <v-app>
        <v-toolbar fixed app :clipped-left="false" extended>
            <v-btn icon @click="$router.go(-1)">
                <v-icon class="icon-light">arrow_back</v-icon>
            </v-btn>
        </v-toolbar>

        <div id="header-image">
            <img :src="logo"/>
        </div>

        <v-content>
            <v-container fluid fill-height pa-0>
                <v-layout>
                    <v-flex xs-12>
                        <v-stepper v-model="step" fill-height style="background-color: transparent">
                            <v-stepper-header>
                                <v-stepper-step :step="steps.personal" :complete="step > steps.personal">
                                    Personal
                                </v-stepper-step>
                                <v-divider v-if="!simpleRegistration"></v-divider>
                                <v-stepper-step :step="steps.social" :complete="step > steps.social" v-if="!simpleRegistration">
                                    Social
                                </v-stepper-step>
                                <v-divider v-if="!simpleRegistration"></v-divider>
                                <v-stepper-step :step="steps.medical" :complete="step > steps.medical" v-if="!simpleRegistration">
                                    Medical
                                </v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :step="steps.address" :complete="step > steps.address">
                                    Address
                                </v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :step="steps.terms">
                                    Terms &amp; Conditions
                                </v-stepper-step>
                            </v-stepper-header>
                            <v-stepper-items fill-height>
                                <v-stepper-content :step="steps.personal">
                                    <v-container fluid grid-list-xl>
                                        <v-layout wrap align-center>
                                            <v-form lazy-validation ref="personal" style="width: 100%">
                                                <v-flex xs12>
                                                    <h2 class="heading">Personal Information</h2>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-text-field label="First name" v-model="data.name" :rules="[rules.required]"/>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-text-field label="Last name" v-model="data.surname" :rules="[rules.required]"/>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-text-field label="Cellphone number" type="number" v-model="data.cellphone" :rules="[rules.required, rules.cellphone]"/>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-text-field label="ID number" type="number" v-model="data.id" :rules="[rules.required, rules.idnumber]" v-if="!simpleRegistration"/>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-select :items="genders" v-model="data.sex" label="Gender" :rules="[rules.required]" v-if="!simpleRegistration"/>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-text-field label="Password" type="password" v-model="data.password" :rules="[rules.required, rules.password]"/>
                                                </v-flex>
                                            </v-form>
                                        </v-layout>
                                    </v-container>
                                </v-stepper-content>
                                <v-stepper-content :step="steps.social">
                                    <v-container fluid grid-list-xl>
                                        <v-layout wrap align-center>
                                            <v-form lazy-validation ref="social" style="width: 100%">
                                                <v-flex xs12>
                                                    <h2 class="heading">Social Information</h2>
                                                    <p class="signup-subheading">optional</p>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-select :items="languages"
                                                              v-model="data.language_id"
                                                              label="Language"
                                                              item-text="label"
                                                              item-value="id"/>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-select label="Are You a Smoker?" :items="['Yes', 'No']" v-model="data.smoker"/>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-select label="Do You Drink Alchohol?" :items="['Yes', 'No']" v-model="data.drinker"/>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0 v-if="data.sex == 'Female'">
                                                    <v-select label="Are you pregnant?" :items="['Yes', 'No']" v-model="data.pregnant"/>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-text-field label="I.C.E (in case of emergency) #1" type="telephone" v-model="data.ice1" :rules="[rules.cellphone]"/>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-text-field label="I.C.E (in case of emergency) #2" :error-messages='iceDuplicateCheck()' type="telephone" v-model="data.ice2" :rules="[rules.cellphone]"/>
                                                </v-flex>
                                            </v-form>
                                        </v-layout>
                                    </v-container>
                                </v-stepper-content>
                                <v-stepper-content :step="steps.medical">
                                    <v-container fluid grid-list-xl>
                                        <v-layout wrap align-center>
                                            <v-form lazy-validation ref="medical" style="width: 100%">
                                                <v-flex xs12>
                                                    <h2 class="heading">Medical Information</h2>
                                                    <p class="signup-subheading">optional</p>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-text-field label="Allergies" v-model="data.allergies"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-text-field label="Chronic Diseases" v-model="data.diseases"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-select label="Blood Group" :items="bloodGroups" v-model="data.bloodGroup"/>
                                                </v-flex>
                                            </v-form>
                                        </v-layout>
                                    </v-container>
                                </v-stepper-content>
                                <v-stepper-content :step="steps.address">
                                    <v-container fluid grid-list-xl>
                                        <v-layout wrap align-center>
                                            <v-form lazy-validation ref="address" style="width: 100%">
                                                <v-flex xs12>
                                                    <h2 class="heading">Address</h2>
                                                    <p class="signup-subheading">optional</p>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-text-field v-model="data.home_address_1" label="Address Line 1" type="text"/>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-text-field v-model="data.home_address_2" label="Address Line 2" type="text"/>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-text-field v-model="data.home_city" label="City" type="text"/>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-text-field v-model="data.home_province" label="Province" type="text"/>
                                                </v-flex>
                                                <v-flex xs12 d-flex pt-0 pb-0>
                                                    <v-text-field v-model="data.home_postal_code" label="Postal Code" type="number"/>
                                                </v-flex>
                                            </v-form>
                                        </v-layout>
                                    </v-container>
                                </v-stepper-content>
                                <v-stepper-content :step="steps.terms">
                                    <v-container fluid grid-list-xl>
                                        <v-layout wrap align-center class="terms-content">
                                            <v-flex xs12>
                                                <h2 class="heading">Terms &amp; Conditions</h2>
                                            </v-flex>
                                            <v-flex xs12 class="description">
                                                <vas-terms/>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
        <v-footer app>
            <v-btn color="primary" flat small class="text-xs-right" @click="previous" v-if="step > steps.personal">
                <v-icon>chevron_left</v-icon>
                Previous
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat small class="text-xs-right" @click="next" v-if="step < steps.terms">
                Next
                <v-icon>chevron_right</v-icon>
            </v-btn>

            <v-btn color="primary" flat small class="text-xs-right" @click="register" v-if="step == steps.terms">
                Register
            </v-btn>
        </v-footer>
        <v-dialog v-model="showTermsMessage" :persistent="true">
            <v-card>
                <v-card-text>
                    Please read the Terms &amp; Conditions till the end before continuing.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="showTermsMessage = false">
                        Okay
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showError" :persistent="true">
            <v-card>
                <v-card-text>
                    {{ errorMessage }}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="showError = false">
                        Okay
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showComplete" :persistent="true">
            <v-card>
                <v-card-text>
                    Your registration has been completed.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="$router.go(-1)">
                        Okay
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>
<script>
    import vas from "@/lib/VASClient"
    import {mapState} from 'vuex'

    var config = require('../../../variants/' + BUILD_VARIANT + '/config.js').default;

    var Luhn = require('luhn-js')

    export default {
        data() {
            return {
                genders: [],
                languages: [],
                bloodGroups: [],
                step: 1,
                logo: require('../../../variants/' + BUILD_VARIANT + '/logo.png'),
                showTermsMessage: false,
                showComplete: false,
                showError: false,
                errorMessage: '',
                steps: {
                    personal: 1,
                    social: 2,
                    medical: 3,
                    address: 4,
                    terms: 5
                },
                data: {
                    termsRead: false,
                    name: '',
                    surname: '',
                    cellphone: '',
                    id: '',
                    password: '',
                    allergies: null,
                    diseases: null,
                    bloodGroup: null,
                    dependancies: null,
                    smoker: null,
                    drinker: null,
                    pregnant: null,
                    ice1: null,
                    ice2: null,
                    language_id: null,
                    sex: null,
                    home_address_1: null,
                    home_address_2: null,
                    home_city: null,
                    home_province: null,
                    home_postal_code: null,
                    config: null
                },
                simpleRegistration: config.registration.simple,
                rules: {
                    required(value) {
                        if (!value) {
                            return 'Required';
                        }

                        return true;
                    },
                    duplicateCheck(value) {

                    },
                    cellphone(value) {
                        if (value == null || value == '') {
                            return true;
                        }

                        var message = 'Please enter a valid cellphone number';

                        if (isNaN(value)) {
                            return message;
                        }

                        if (value.length < 10 || value.length > 12) {
                            return message;
                        }

                        if (value[0] !== '0' && (value[0] + value[1]) != '27') {
                            return message;
                        }

                        return true;
                    },
                    idnumber(value) {
                        var message = 'Please enter a valid ID number';

                        if (isNaN(value)) {
                            return message;
                        }

                        if (value.length != 13) {
                            return message;
                        }

                        if (!Luhn.isValid(value)) {
                            return message;
                        }

                        return true;
                    },
                    password(value) {
                        if (value.length < 6) {
                            return 'Please provide a password longer than 6 characters';
                        }

                        return true;
                    }
                }
            }
        },
        methods: {
            next() {
                if (this.step == this.steps.personal && !this.$refs.personal.validate()) {
                    return;
                }

                console.log("Validate: " + this.$refs.social.validate());
                console.log("Duplicate: " + this.iceDuplicateCheck());

                if (this.step == this.steps.social && (!this.$refs.social.validate() || this.iceDuplicateCheck() !== '')) {
                    return;
                }

                if (this.step == this.steps.medical && !this.$refs.medical.validate()) {
                    return;
                }

                if (this.step == this.steps.address && !this.$refs.address.validate()) {
                    return;
                }

                this.step++;
            },
            previous() {
                this.step--;
            },
            register() {
                var self = this;

                if (!this.termsRead) {
                    this.showTermsMessage = true;

                    return;
                }

                Loading.show('');

                vas.register(this.data.id,
                    this.data.name,
                    this.data.surname,
                    this.data.cellphone,
                    this.data.password,
                    this.data.home_address_1,
                    this.data.home_address_2,
                    this.data.home_city,
                    this.data.home_province,
                    this.data.home_postal_code,
                    this.data.dependancies,
                    this.data.ice1,
                    this.data.ice2,
                    this.data.age,
                    this.data.sex,
                    this.data.race,
                    this.data.language_id,
                    this.data.pregnant,
                    this.data.weight,
                    this.data.height,
                    this.data.smoker,
                    this.data.drinker,
                    this.data.bloodGroup,
                    this.data.diseases,
                    this.data.allergies
                ).then(function (response) {
                    Loading.hide();
                    if (!response.status) {
                        self.errorMessage = response.msg;
                        self.showError = true;
                    } else {
                        self.showComplete = true;
                    }
                }).catch(function (error) {
                    Loading.hide();

                    Snackbar.show('An error has occurred, please try again');
                });
            },
            handleScroll(event) {
                if (this.step != this.steps.terms) {
                    return;
                }

                const el = document.scrollingElement || document.documentElement;

                if (document.documentElement.scrollHeight - el.scrollTop === document.documentElement.clientHeight) {
                    this.termsRead = true;
                }
            },
            iceDuplicateCheck() {
                if (this.data.ice1 == '' || this.data.ice1 == null) {
                    return '';
                }

                if (this.data.ice2 == '' || this.data.ice2 == null) {
                    return '';
                }

                if (this.data.ice1 === this.data.ice2) {
                    return 'Please enter a unique I.C.E. number';
                }

                return '';
            },
        },
        mounted() {
            this.genders = vas.getGenders();
            this.languages = vas.getLanguages();
            this.bloodGroups = vas.getBloodGroups();

            if (this.simpleRegistration) {
                this.steps = {
                    personal: 1,
                    address: 2,
                    terms: 3,
                    medical: -1,
                    social: -2
                };
            }
            return;
            this.data = {
                termsRead: false,
                name: 'William',
                surname: 'Brooks',
                cellphone: '0829283948',
                id: '8211275123086',
                password: '123456789',
                allergies: 'No Allergies',
                diseases: 'No Diseases',
                bloodGroup: 'O Positive (O+)',
                dependancies: '3',
                smoker: 'No',
                drinker: 'Yes',
                pregnant: 'No',
                ice1: '0829283948',
                ice2: '0829283948',
                language_id: 4,
                sex: 'Male',
                home_address_1: 'Address Line 1',
                home_address_2: 'Address Line 2',
                home_city: 'City',
                home_province: 'Province',
                home_postal_code: '12345'
            }
        },
        computed: {
            ...mapState(
                ['auth']
            )
        },
        beforeMount() {
            window.addEventListener('scroll', this.handleScroll);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }
</script>
